import { render } from "./frequencyLimit.vue?vue&type=template&id=60f345e6&scoped=true"
import script from "./frequencyLimit.vue?vue&type=script&lang=js"
export * from "./frequencyLimit.vue?vue&type=script&lang=js"

import "./frequencyLimit.vue?vue&type=style&index=0&id=60f345e6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-60f345e6"

export default script